import * as React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import Link from '../../components/link';
import NaviBar from '@src/business-components/navibar';
import Footer from '@src/business-components/footer';
import FloatRight from '@src/business-components/float-right';
import OpenBetaHighlights from './components/open-beta-highlights';
import Feature from './components/feature';
import SectIntroduction from './components/sect-introduction';
import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import FollowUs from './components/follow-us';

// import kv_image from './images/kv_image.jpg';
// import minPaiPNG from './images/minPaiPNG.png';
import ztWenAnPNG from './images/ztWenAnPNG.png';

// 163 513
// import logoPNG from './images/test/257x94.png';

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <div className={styles.main}>
        <div className={styles.main_bg} />
        <div className={styles.naviBarBox}>
          <NaviBar store={store.navibarStore} />
        </div>

        {/* <img src={minPaiPNG} className={styles.min_pai} alt="门牌铭牌" /> */}
        <img src={store.kvData.kv_image} className={styles.kv_bg} alt="KV背景图" />
        {/* <img src={store.kvData.kv_image} className={styles.kv_bg} alt="KV背景图" />
        {store.kvData.kv_video && <video src={store.kvData.kv_video} className={styles.kv_video} loop autoPlay muted />} */}
        {store.kvData.kv_video && <video src={store.kvData.kv_video} className={styles.kv_video} loop autoPlay muted />}
        <div className={styles.kv_content}>
          {/* <img src={logoPNG} className={styles.logo} alt="" /> */}
          <img
            // src={store.game_stage_config === 'beta_download' ? require('./images/slogan-gold.png') : require('./images/slogan-date.png')}
            src={ztWenAnPNG}
            className={styles.slogan}
            alt=""
          />
          {/* {store.game_stage_config === 'beta_download' && <img className={styles.slogan_icon} src={require('./images/slogan-icon.png')} alt="" />} */}
          {store.kvData.kv_pv_video && <Link className={styles.btn_play} onClick={store.openVideo} data-name="打开视频" />}

          <div className={styles.game_leave}>
            <AgeAppropriateTips gameName="剑侠情缘零" />
          </div>
          {store.game_stage_config === 'appointment' ? (
            <div className={styles.kv_appointment} data-name="预约阶段">
              <Link className={cx(styles.btn_appointment, store.phone && styles.done)} data-name="预约按钮" onClick={store.showAppointment} />
              <div className={styles.appointment_count}>
                已有 <span>{store.subscribeTotal}</span> 人预约
              </div>
            </div>
          ) : (
            <div className={cx(styles.appointment_download, store.game_stage_config === 'beta_download' && styles.ad_download)} data-name="预约+下载">
              <div className={styles.appointment_download_qrcode} key={store.indexQrcode}>
                {store.indexQrcode && (
                  <div className={styles.qrcode_iframe}>
                    <iframe title="首页扫码下载" src={store.indexQrcode} />
                  </div>
                )}
                {/* <img src={require('./images/qrcode.png')} alt="" /> */}
              </div>
              <div className={styles.download_btns} data-name="苹果下载，安卓下载">
                <Link className={cx(styles.btn_download, styles.btn_download_ios)} onClick={() => store.handleDownload('apple')} />
                <Link className={cx(styles.btn_download, styles.btn_download_android)} onClick={() => store.handleDownload('android')} />
              </div>
              <Link className={styles.btn_download_pc} data-name="电脑下载" onClick={() => store.handleDownload('pc')} />
              <Link className={styles.btn_official_recharge} data-name="官方充值" onClick={() => store.handleDownload('charge')} />
              {store.game_stage_config === 'pre_download' && (
                <Link
                  className={styles.btn_ad_appointment}
                  data-name="立即预约"
                  onClick={() => {
                    store.showAppointment();
                  }}
                />
              )}
            </div>
          )}
        </div>
        {/* 1. 公测亮点 */}
        <OpenBetaHighlights store={store.openBetaHighlightsStore} />

        {/* 2. 游戏特色 */}
        <Feature store={store.featureStore} />

        {/* 3. 门派介绍 */}
        <SectIntroduction />

        {/* 4. 关注我们 */}
        <FollowUs store={store.followUsStore} />

        {/* 5. 底部 */}
        {store.footerVisible && (
          <div className={styles.footer_wrap}>
            <div className={styles.footer_content} onClick={store.closeFooter} />
            <Footer store={store.footerStore} />
          </div>
        )}

        <FloatRight store={store.floatRightStore} />
      </div>
    </Page>
  );
};

export default observer(Main);
